import { AbstractRepository } from '@/repositories/abstract-repository';
import { CrmTypeOption } from '@/crm-types/models/crm-type';

export class TaskResultsRepository extends AbstractRepository<CrmTypeOption> {
    readonly endpoint = 'types/tasks/results';
}
